import React, { useState, useEffect } from "react";
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';

const AccelerateHistory = () => {
  const [history, setHistory] = useState([]);
  const [activeTab, setActiveTab] = useState('today');
  const [showCustomDatePopup, setShowCustomDatePopup] = useState(false);
  const [customDates, setCustomDates] = useState({ from_date: '', to_date: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchHistory('today');
  }, []);

  const handleHistoryChange = async (category) => {
    setActiveTab(category);
    if (category === 'custom') {
      setShowCustomDatePopup(true);
      return;
    }
    fetchHistory(category);
  };

  const fetchHistory = async (category, from = '', to = '') => {
    const hostData = getItemFromLocalStorage('hostProfile');
    let formData = new FormData();
    formData.append('token', hostData.host_access_token);
    formData.append('category', category);
    if (from) formData.append('from_date', from);
    if (to) formData.append('to_date', to);

    try {
      setLoading(true);
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url: `${params.baseURL}${params.endpoints.accelerateHistory}`,
        data: formData
      });
      if (response.data.items && Array.isArray(response.data.items)) {
        setHistory(response.data.items || []);
      } else {
        setHistory([]);
      }
    } catch (error) {
      console.error(error);
      setHistory([]);
    } finally {
      setLoading(false);
    }
  };

  const tabs = ['today', 'week', 'month', 'year', 'custom'];

  return (
    <div>
      <Helmet>
        <title>Accelerate History</title>
        <meta name="description" content="" />
      </Helmet>

      <div className="earning-section">
        <section className="pay-history-section chart-section">
          <div className="row">
            <div className="col-md-12">
              <div style={{ width: '100%', maxWidth: '100%' }}>

                <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
                  {tabs.map((tab) => (
                    <button
                      key={tab}
                      onClick={() => handleHistoryChange(tab)}
                      style={{
                        flex: 1,
                        padding: '8px 12px',
                        background: activeTab === tab ? '#1890ff' : '#f0f0f0',
                        color: activeTab === tab ? '#fff' : '#000',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        minWidth: '100px',
                        textTransform: 'capitalize',
                      }}
                    >
                      {tab === 'week' ? 'This Week' :
                        tab === 'month' ? 'This Month' :
                        tab === 'year' ? 'This Year' :
                        tab === 'custom' ? 'Custom' :
                        'Today'}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pay-history-section">
          <div className="phs-box w-100">
            <div className="phsvb">
              <h2 className="tnstxt">Accelerate History</h2>
              <div className="table-flex">
                <div className="table-row table-header">
                  <div className="table-cell">LISTING</div>
                  <div className="table-cell">OFFER</div>
                  <div className="table-cell">GENERATED</div>
                  <div className="table-cell">SENT</div>
                  <div className="table-cell">REDEEMED</div>
                  <div className="table-cell">BOOKINGS</div>
                  <div className="table-cell">DATE</div>
                  <div className="table-cell">STATUS</div>
                </div>
                {loading ? (
                  <div className="table-row">
                    <div className="table-cell text-center" style={{ flex: '1 0 100%' }}>
                      Loading...
                    </div>
                  </div>
                ) : (
                  history.map((item, index) => (
                    <div className="table-row" key={index}>
                      <div className="table-cell">{item.listing_title}</div>
                      <div className="table-cell">{item.offer_title}</div>
                      <div className="table-cell">{item.totalGenerated}</div>
                      <div className="table-cell">{item.totalSent}</div>
                      <div className="table-cell">{item.totalRedemmed}</div>
                      <div className="table-cell">{item.totalBookings}</div>
                      <div className="table-cell">{item.created_time}</div>
                      <div className="table-cell">{item.status}</div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </section>
      </div>

      {showCustomDatePopup && (
        <div className="confirmation-popup-overlay">
          <div className="confirmation-popup">
            <div className="popup-body mb-4" style={{ position: 'relative' }}>
              <div className="euc-close" style={{ top: '-6px' }} onClick={() => setShowCustomDatePopup(false)}>
                <img src={'/assets/img/icons/popup_close.png'} className="img-fluid" alt="" style={{ width: '30px' }} />
              </div>
              <h4>Select Custom Date Range</h4>
            </div>

            <div className="form-floating mb-4">
              <input
                type="date"
                className="form-control"
                value={customDates.from_date}
                onChange={(e) => setCustomDates({ ...customDates, from_date: e.target.value })}
                required
              />
              <label>From</label>
            </div>
            <div className="form-floating">
              <input
                type="date"
                className="form-control"
                value={customDates.to_date}
                onChange={(e) => setCustomDates({ ...customDates, to_date: e.target.value })}
                required
              />
              <label>To</label>
            </div>
            <div className="mt-4">
              <button
                onClick={() => {
                  setShowCustomDatePopup(false);
                  fetchHistory('custom', customDates.from_date, customDates.to_date);
                }}
                className="btn btn-black w-100"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccelerateHistory;
